import { Box } from '@mui/material';
import React from 'react';
import { getFormattedDateFromIsoString } from '~/src/utils/date';
import { Edit, Trash, Type } from 'react-feather';
import {
  CardListItemWithActions,
  CardListItemMetaText,
} from '~/src/components/CardList';

export const CardListContactsTable = ({
  contacts,
  handleEdit,
  handleView,
  handleDelete,
}) => {
  return contacts.map((contact) => {
    const actions = [
      {
        label: 'Edit',
        icon: <Edit size={16} />,
        onClick: () => handleEdit(contact),
      },
      {
        label: 'View',
        icon: <Type size={16} />,
        onClick: () => handleView(contact),
      },
      {
        label: 'Delete',
        icon: <Trash size={16} />,
        onClick: () => handleDelete(contact),
      },
    ];

    const lastModifiedDate = getFormattedDateFromIsoString(
      contact.lastModified,
    );
    const lastModifiedBy = contact.lastModifiedBy?.displayName ?? '';

    if (lastModifiedBy.length === 0) {
      console.error(
        `Missing field contact.lastModifiedBy in contact ${contact.id}`,
      );
    }

    const lastUpdated = [lastModifiedDate, lastModifiedBy]
      .filter((exists) => !!exists)
      .join(', ');

    return (
      <Box pb={1} key={contact.id}>
        <CardListItemWithActions
          key={contact.id}
          title={{
            label: `${contact.firstName} ${contact.lastName}`,
            meta: [contact.email],
          }}
          meta={
            <CardListItemMetaText>
              Last updated: {getFormattedDateFromIsoString(lastUpdated)}
            </CardListItemMetaText>
          }
          actions={{
            actions,
            primary: undefined,
          }}
        />
      </Box>
    );
  });
};
